import { useId } from 'react';
import { cn } from '../lib/cn.js';

/** Interruptor acessível (role=switch) com rótulo e descrição clicáveis; alvo de toque ≥ 44 px. */
export function Switch({ checked, onChange, label, description, disabled }: {
  checked: boolean; onChange: (v: boolean) => void; label: string; description?: string; disabled?: boolean;
}) {
  const id = useId();
  return (
    <div className="flex items-start justify-between gap-4">
      <label htmlFor={id} className="min-w-0 flex-1 cursor-pointer">
        <span className="block font-medium text-fg">{label}</span>
        {description && <span id={`${id}-d`} className="mt-0.5 block text-[0.9em] text-fg-muted">{description}</span>}
      </label>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-describedby={description ? `${id}-d` : undefined}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className="grid h-11 w-14 shrink-0 place-items-center disabled:opacity-50"
      >
        <span className={cn('relative h-7 w-12 rounded-full transition-colors', checked ? 'bg-primary' : 'bg-border-strong')}>
          <span className={cn('absolute top-0.5 left-0.5 size-6 rounded-full bg-white shadow-card transition-transform',
            checked && 'translate-x-5')} />
        </span>
        <span className="sr-only">{checked ? 'Ativado' : 'Desativado'}</span>
      </button>
    </div>
  );
}
